<template>
  <div class="feedback-modal">
    <div class="feedback-text-container">
      <p class="feedback-text-length">
        {{ feedback.length }} / {{ MAX_FEEDBACK_LENGTH }}
      </p>
      <textarea
        v-model="feedback"
        placeholder="Please provide as much detail as possible."
        rows="8"
        :maxlength="MAX_FEEDBACK_LENGTH"
      />
    </div>
    <FileAttachments
      :model-value="[]"
      file-type-error-message="Invalid file format. Only .jpg, .jpeg, .png, .gif or PDF files accepted. Please try again."
    />
    <div class="feedback-actions">
      <MsgButton
        type="secondary"
        :full-width="false"
        @click="emit('cancel')"
      >
        Cancel
      </MsgButton>
      <MsgButton
        type="primary"
        :full-width="false"
        :disabled="feedback.length === 0"
        @click="handleSubmitFeedback()"
      >
        Submit
      </MsgButton>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import FileAttachments from "../FileAttachments.vue";
import MsgButton from "../../MsgUi/MsgButton.vue";
const MAX_FEEDBACK_LENGTH = 500;
const emit = defineEmits(["cancel", "submit"]);
const feedback = ref("");
function handleSubmitFeedback() {
  emit("submit");
}
</script>

<style scoped>
.feedback-modal{--color-text-secondary:#616161;display:flex;flex-direction:column;gap:17px}.feedback-text-container{display:flex;flex-direction:column;gap:11px}.feedback-text-length{align-self:flex-end;color:var(--color-text-secondary);font-family:Inter;font-size:12px;margin:0}textarea{box-sizing:border-box;font-family:Inter;font-size:16px;padding:8px;width:100%}.feedback-actions{display:flex;gap:12px;justify-content:flex-end}
</style>
